import { createContext } from '../dissolve/utils';
import { Settings } from '../types';

type PopupContext = {
  settings: Settings;
  blockingActionInProgress?: boolean;
};

const [usePopupContext, PopupContextProvider, PopupContextConsumer] =
  createContext<PopupContext>();

export { usePopupContext, PopupContextProvider, PopupContextConsumer };
